<template lang="pug">
  .dashboard-quick-links
    v-card.mx-3.pa-4(flat outlined style="border: 1px solid var(--v-primary200);")
      h6.basic1000--text {{ $t('share_your_agent_links') }}
      v-select.mt-4(v-model="link" item-text="name" return-object :items="links" outlined dense background-color="basic200" hide-details placeholder="Select link to share")
        template(v-slot:append)
          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
        template(v-slot:item="{ index, item, attrs }")
          div.py-2
            div.s1.mb-1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.name }}
      v-layout.mt-4
        v-spacer
        v-btn.info500(color='info500' dark depressed height=32 @click="link ?  clickShare() : '' ")
          .button-AA-small.basic100--text {{ $t('share') }}

    .modals(v-if="link")
      y-dialog.white(v-model='openPrintQR' max-width="400px")
        v-card
          v-row.pt-3(no-gutters align="center")
            v-col(cols="8" offset="2" align="center")
              v-chip(color="black" :to="`/print-qr?link=${link.url}`" target="_blank" link outlined small)
                | {{ $t('print') }}
                v-icon.ml-2(small) mdi-cloud-print-outline
            v-col.pr-3(cols="2" align="center")
              v-btn(icon small @click="openPrintQR = false; shareSheet = false")
                v-icon mdi-close
          v-card(align="center" flat)
            div.d-flex.justify-center.align-center(style="position: absolute; height: 100%; width: 100%")
              img(:src="require('@/assets/images/icon_yezza_qr.png')" style="width: 75px")
            vue-qrcode(:value="getQRLinkURL()" :options="{ width: 270 }")
      y-bottom-sheet(v-model='shareSheet' inset max-width="600px")
        v-list
          div.pt-2.px-6.s2.primary400--text {{ $t('share_url_by') }}
          v-list-item(@click="shareUrlToSocial('whatsapp')")
            v-list-item-avatar.my-0
              v-icon(color="#455A64" size="24") fab fa-whatsapp
            v-list-item-title.s2.basic1000--text WhatsApp
          v-list-item(@click="shareUrlToSocial('facebook')")
            v-list-item-avatar.my-0
              v-icon(color="#3b5998" size="24") fab fa-facebook
            v-list-item-title.s2.basic1000--text Facebook
          v-list-item(@click="copyUrl" v-clipboard:copy="getBrandedLinkURL()")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-content-copy
            v-list-item-title.s2.basic1000--text Copy Link
              div.c1.primary400--text {{getBrandedLinkURL()}}
          v-list-item(@click="openPrintQR = true")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-qrcode
            v-list-item-title.s2.basic1000--text {{ $t('print_qr_code') }}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'AcDashboardQuickLinks',
  props: ['company'],
  components: { VueQrcode },
  data: () => ({
    link: null,
    links: [],
    fetchCount: 100,
    page: 1,
    openPrintQR: false,
    openEmbedDialog: false,
    shareSheet: false,
    customLinkSlug: null,
    customDomainURL: null
  }),
  computed: {
    ...mapState('user', ['member']),
  },
  watch: {
    shareSheet (val) {
      if (!val) {
        this.customLinkSlug = null
      }
    }
  },
  mounted () {
    this.links = [
      { name: 'Aqiqah & Qurban', url: `https://aqiqahcentre.com/nadipage?m_id=${this.member.pid}` },
      // { name: 'Qurban', url: `https://aqiqahcentre.com/borang-qurban-mekah?m_id=${this.member.pid}` }
    ]
    this.link = { name: 'Aqiqah & Qurban', url: `https://aqiqahcentre.com/nadipage?m_id=${this.member.pid}` }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getShareLinkURL () {
      return `WhatsApp Now: ${this.link.url}`
    },
    getBrandedLinkURL () {
      return this.link.url
    },
    getShareLinkFB () {
      return this.link.url
    },
    getShortLinkURL () {
      return this.link.url
    },
    getQRLinkURL () {
      return this.link.url
    },
    getShareCustomURL () {
      return this.linkURL + this.customLinkSlug
    },
    shareUrlToSocial(platform) {
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkFB()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL())}`, '_blank')
      }
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    clickShare () {
      this.shareSheet = true
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
</style>